export const ENABLE_USER_BILLING = String(process.env.REACT_APP_ENABLE_USER_BILLING || '').trim().toLowerCase() === 'true'
export const ENABLE_BILLING_COUPONS = true
export const ENABLE_BILLING_POINTS = true
export const BILLING_PAYMENT_PROVIDER = String(process.env.REACT_APP_BILLING_PAYMENT_PROVIDER || '').trim()
export const BILLING_PAYMENT_CONFIRM_ENABLED = Boolean(BILLING_PAYMENT_PROVIDER)
